"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cacheGetEventData_1 = require("./cacheGetEventData");
var CACHE_KEY_PREFIX = 'GET_ELEMENT_AT_CURSOR_';
/**
 * Get an HTML element at cursor from event cache if it exists.
 * If an selector is specified, return the nearest ancestor of current node
 * which matches the selector, or null if no match found in editor.
 * @param editor The editor instance
 * @param event Event object to get cached object from
 * @param selector The expected selector. If null, return the element at cursor
 * @returns The element at cursor or the nearest ancestor with the tag name is specified
 */
function cacheGetElementAtCursor(editor, event, selector) {
    return cacheGetEventData_1.default(event, CACHE_KEY_PREFIX + selector, function () {
        return editor.getElementAtCursor(selector);
    });
}
exports.default = cacheGetElementAtCursor;
//# sourceMappingURL=cacheGetElementAtCursor.js.map